export default __webpack_public_path__ + "static/media/bell-notifs.f1397093.svg";